import React from 'react';

interface PathfinderIconProps {
  className?: string;
}

export function PathfinderIcon({ className = 'h-6 w-6' }: PathfinderIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className={className}
    >
      {/* Node tree with three branches - represents decision paths */}
      {/* Root node */}
      <circle cx="12" cy="19" r="2" strokeLinecap="round" strokeLinejoin="round" />
      {/* Main trunk */}
      <path strokeLinecap="round" strokeLinejoin="round" d="M12 17V12" />
      {/* Center branch to top node */}
      <path strokeLinecap="round" strokeLinejoin="round" d="M12 12V7" />
      <circle cx="12" cy="5" r="2" strokeLinecap="round" strokeLinejoin="round" />
      {/* Left branch */}
      <path strokeLinecap="round" strokeLinejoin="round" d="M12 12L6 7" />
      <circle cx="5" cy="6" r="2" strokeLinecap="round" strokeLinejoin="round" />
      {/* Right branch */}
      <path strokeLinecap="round" strokeLinejoin="round" d="M12 12L18 7" />
      <circle cx="19" cy="6" r="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export default PathfinderIcon;
